/**
 * IOSAudioBypass.tsx
 * =============================================================================
 * Hidden, looping DOM audio element that forces iOS Safari to maintain the
 * audio session as AVAudioSessionCategoryPlayback ("Media" channel), bypassing
 * the physical hardware mute switch.
 *
 * KEY: The `loop` attribute keeps the audio session in "Playback" mode
 * indefinitely. Without it, iOS reverts to "Ambient" when the track ends.
 *
 * CRITICAL FOR MEDIA SESSION: iOS Safari only shows lock screen metadata
 * (title, artist, artwork) when an HTMLMediaElement is actively playing.
 * Web Audio API alone does NOT trigger the Now Playing integration.
 * This <audio> element serves double duty: mute bypass AND media session anchor.
 *
 * AudioEngine.ensureContext() finds this element by ID and calls .play()
 * on the first user gesture, BEFORE creating the AudioContext.
 *
 * @author Neuro-Audio Lab
 */

export function IOSAudioBypass() {
  return (
    <audio
      id="ios-media-bypass"
      src="/audio/near-silence.m4a"
      preload="auto"
      playsInline
      loop
      style={{ display: 'none' }}
    />
  );
}
